import { http } from "../http/Http";
import { TaskType } from "../models/TaskType";
import { ServiceResponse } from "../models/ServiceResponse";
import { GetByFiltersArguments } from "../models/GetByFiltersArguments";

export class TaskTypeService {

    getTaskTypesByFilters = async (apiQueryFilter: GetByFiltersArguments): Promise<ServiceResponse<TaskType[]>> => {
        const { data } = await http.post<ServiceResponse<TaskType[]>>("TaskType/GetByFilters", apiQueryFilter);
        return data;
    };

    getTaskType = async (id: number): Promise<TaskType> => {
        const { data } = await http.get<TaskType>(("TaskType/GetById/" + id.toString()));
        return data;
    };

    addTaskType = async (taskType: TaskType): Promise<ServiceResponse<TaskType>> => {
        const { data } = await http.post<ServiceResponse<TaskType>>("TaskType/Post", taskType);
        return data;
    };

    updateTaskType = async (taskType: TaskType): Promise<ServiceResponse<TaskType>> => {
        const { data } = await http.put<ServiceResponse<TaskType>>("TaskType/Put", taskType);
        return data;
    };

}